import React = require("react");
import {RestDataLoader} from "../dashboard/widgets/unilever/RestDataLoader";
import {AppTranslations} from "../components/Utils/translations/AppTranslations";
import {defaultTheme} from "@vebox/etui-themes";
import {ThemeProvider} from "@vebox/etui-system";
import {veboxDefaultTheme} from "../index";

declare var AppTranslations: AppTranslations;

interface ComponentProps {
    onChange: (values: string[]) => void;
}

interface ComponentState {
    selectedList: string[];
    options: StatusValue[];
}

interface StatusValue {
    key: string;
    value: string;
}

export class EquipmentStatusFilter extends React.Component<ComponentProps, ComponentState> {
    constructor(props) {
        super(props);
        this.state = {
            selectedList: [],
            options: [],
        };
    }

    public componentDidMount() {
        RestDataLoader.loadData(
            "equipment/statuses",
            {},
            (data) => {
                this.setState({
                    options: data.list,
                    selectedList: [],
                }, () => {
                    this.props.onChange(this.state.selectedList);
                });
            },
            () => {
                console.error("Error in loading equipment statuses.");
            },
        );
    }

    public render() {
        let classNames = "filterTitle filterTitleCheckList capitalize";
        if ((this.state.selectedList || []).length > 0) {
            classNames += " filtersGroupTitleEnlight";
        }
        return (
            <ThemeProvider theme={veboxDefaultTheme}>
                <div>
                    <p
                        className={classNames}
                        onClick={this.closeCheckboxList}
                        style={{cursor: "pointer"}}
                    >
                        {AppTranslations.filters.statuses.equipmentStatus.title}
                    </p>
                    <div
                        id="openCheckboxListFiltersEquipmentStatusButton"
                        onClick={this.openCheckboxList}
                        className="filterContent openChecklistFilterButton"
                    >
                        <p>...</p>
                    </div>
                    <ul id="filtersEquipmentStatusList" className="filterContent filterContentCheckList">
                        {this.state.options.map((x, i) => (
                            <li key={i}>
                                <input
                                    type={"checkbox"}
                                    onChange={this.onChangeCheckbox(x.key)}
                                    checked={this.state.selectedList.findIndex((s) => s === x.key) > -1}
                                    style={{marginRight: 10}}
                                />
                                <p className="subFilterCheckListTitle capitalize">{x.value}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </ThemeProvider>
        );
    }

    public reset = () => {
        this.setState({
            selectedList: [],
        }, () => {
            this.props.onChange(this.state.selectedList);
            this.closeCheckboxList();
        });
    }

    private onChangeCheckbox = (value) => {
        return (e) => {
            if (e.target.checked) {
                this.setState({
                    selectedList: [value, ...this.state.selectedList],
                }, () => {
                    this.props.onChange(this.state.selectedList);
                });
            } else {
                this.setState({
                    selectedList: this.state.selectedList.filter((sl) => sl !== value),
                }, () => {
                    this.props.onChange(this.state.selectedList);
                });
            }
        };
    }

    private openCheckboxList() {
        (window as any).openCheckboxList(
            "#openCheckboxListFiltersEquipmentStatusButton",
            "#filtersEquipmentStatusList",
        );
    }

    private closeCheckboxList() {
        (window as any).closeCheckboxList(
            "#openCheckboxListFiltersEquipmentStatusButton",
            "#filtersEquipmentStatusList",
        );
    }
}
